export const PAGE_NAMES = {
  HOME: '/',
  ADMIN: '/admin',
  NOT_FOUND: '/not-found',
  USER_PROFILE: '/user/profile',
  SERVER_ERROR: '/server-error',

  CONTACTS: '/contacts',
  BLOG: '/posts',
  ABOUT_US: '/about-us',
  PRIVACY_POLICY: '/privacy-policy',
  OUR_STATUTE: '/our-statute',
  SUPPORT: '/support',
  COURSES: '/courses',
  CATEGORIES: '/categories',

  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  RESET_PASSWORD: '/reset-password',
  UNSUBSCRIBE_USER: '/unsubscribe-user',
  ACCOUNT_CONFIRMATION: '/account-confirmation',
  THANK_YOU_FOR_SENDING_REQUEST: '/thank-you-for-sending-request',

  USER_DIALOGS: '/user/support',
  USER_COURSES: '/user/courses',
  USER_FAVORITE_TOPICS: '/user/favorite-topics',

  POSTS_SEARCH: '/posts/search',
  POST: '/posts/:alias',
  POSTS_TAGS: '/posts/tags/:alias',
  CATEGORY: '/categories/:alias',

  COURSE: '/courses/:alias',
  START_COURSE: '/courses/:alias/start-course',

  VIDEO_COURSE: '/video-courses/:alias',
  ONLINE_COURSE: '/online-courses/:alias',

  ADMIN_CONSULTATIONS: '/admin/consultations',
  ADMIN_POST_ADD: '/admin/posts/add',
  ADMIN_POSTS: '/admin/posts',
  ADMIN_POST_EDIT: '/admin/posts/:alias',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_COMPANIES: '/admin/companies',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_PROFILE: '/admin/user/profile',
  ADMIN_USER_DIALOGS: '/admin/user/support',
  ADMIN_USER_FAVORITE_TOPICS: '/admin/user/favorite-topics',
  ADMIN_COURSE_ADD: '/admin/courses/add',
  ADMIN_COURSE_EDIT: '/admin/courses/:alias',

  CLIENTS_DASHBOARD: '/clients',
  CLIENTS_WORKSPACE: '/clients/workspace',
  CLIENTS_INFLUENCERS: '/clients/partners',
  CLIENTS_PAYMENTS: '/clients/payments',
  CLIENTS_REQUESTS: '/clients/requests',
  CLIENTS_STATISTICS: '/clients/statistics',
  CLIENTS_NOTIFICATIONS: '/clients/notifications',
  CLIENTS_SETTINGS: '/clients/settings',
  CLIENTS_MANAGERS: '/clients/managers',
  CLIENTS_PRODUCTS: '/clients/products',
  CLIENTS_COMPANIES: '/clients/companies',
  CLIENTS_SIGN_IN: '/clients/sign-in',
  CLIENTS_SIGN_UP: '/clients/sign-up',
  CLIENTS_FOUNDERS: '/clients/founders',
  CLIENTS_PROFILE: '/clients/profile',
  CLIENTS_CONNECT_PLATFORM: '/clients/connect-platform',

  LANDINGS_SPEED_READING_FOR_ADULTS: '/landings/speed-reading-for-adults',

  PLATFORM_COURSES: '/platform/online-courses',
  PLATFORM_VIDEO_COURSES: '/platform/video-courses',
  PLATFORM_TEACHERS: '/platform/teachers',
  PLATFORM_MANAGERS: '/platform/managers',
  PLATFORM_STUDENTS_LIST: '/platform/students/list',
  PLATFORM_STUDENTS_BOARD: '/platform/students/board',
  PLATFORM_CALENDAR: '/platform/calendar',
  PLATFORM_USER_PROFILE: '/platform/user/profile',
  PLATFORM_USER_DIALOGS: '/platform/user/support',
  PLATFORM_USER_FAVORITE_TOPICS: '/platform/user/favorite-topics',
  PLATFORM_USER_NOTIFICATIONS: '/platform/user/notifications',

  PLATFORM_VIDEO_COURSE_METRICS: '/platform/video-courses/:alias/:courseCategoryAlias/metrics',
  PLATFORM_ONLINE_COURSE_METRICS: '/platform/online-courses/:alias/:courseCategoryAlias/metrics',
  PLATFORM_ONLINE_COURSE_SURVEYS: '/platform/online-courses/:alias/:courseCategoryAlias/surveys',
  PLATFORM_VIDEO_COURSE_DASHBOARD: '/platform/video-courses/:alias/:courseCategoryAlias/player',

  PLATFORM_ONLINE_COURSE: '/platform/online-courses/:alias',
  PLATFORM_ONLINE_COURSE_CATEGORIES: '/platform/online-courses/:alias/categories',
  PLATFORM_ONLINE_COURSE_THANK_YOU: '/platform/online-courses/:alias/thank-you',
  PLATFORM_VIDEO_COURSE_THANK_YOU: '/platform/video-courses/:alias/thank-you',
  PLATFORM_VIDEO_COURSE_CATEGORIES: '/platform/video-courses/:alias/categories',

  PLATFORM_ONLINE_COURSE_BOARD: '/platform/online-courses/:alias/:courseCategoryAlias/board',
  PLATFORM_VIDEO_COURSE_BOARD: '/platform/video-courses/:alias/:courseCategoryAlias/board',

  PLATFORM_ONLINE_COURSE_LESSON: '/platform/online-courses/:alias/:courseCategoryAlias/:lessonAlias',
  PLATFORM_ONLINE_COURSE_TRIAL_LESSON: '/platform/online-courses/:alias/onboarding',
  PLATFORM_ONLINE_COURSE_LESSON_CALL: '/platform/online-courses/:alias/:courseCategoryAlias/:lessonAlias/call',
  PLATFORM_ONLINE_COURSE_LESSON_DETAILS: '/platform/online-courses/:alias/:courseCategoryAlias/:lessonAlias/details',
  PLATFORM_ONLINE_COURSE_LESSON_RESULTS: '/platform/online-courses/:alias/:courseCategoryAlias/:lessonAlias/results',

  PLATFORM_ONLINE_COURSE_WITHOUT_ALIAS: '/platform/online-courses/',
  PLATFORM_VIDEO_COURSE_WITHOUT_ALIAS: '/platform/video-courses/',
} as const;

export const SLIDER_ITEM_TYPE = {
  EXTENDED: 'EXTENDED',
  VIDEO: 'VIDEO',
  CATEGORY: 'CATEGORY',
  PRODUCT: 'PRODUCT',
  CONCISE: 'CONCISE',
} as const;

export const LANGUAGE = {
  UA: 'ua',
  RU: 'ru',
  EN: 'en',
} as const;

type LanguageValue = (typeof LANGUAGE)[keyof typeof LANGUAGE];

type LanguageOption = Readonly<{
  label: LanguageValue;
  value: LanguageValue;
}>;

export const LANGUAGE_OPTIONS: readonly LanguageOption[] = [
  {
    label: LANGUAGE.UA,
    value: LANGUAGE.UA,
  },
  {
    label: LANGUAGE.RU,
    value: LANGUAGE.RU,
  },
  {
    label: LANGUAGE.EN,
    value: LANGUAGE.EN,
  },
] as const;

export type PageName = (typeof PAGE_NAMES)[keyof typeof PAGE_NAMES];
export type SliderItemType = (typeof SLIDER_ITEM_TYPE)[keyof typeof SLIDER_ITEM_TYPE];
export type Language = LanguageValue;
